const unitlessNumberRegex = /^\d+$/;
import type {Context} from '../types';

/**
 * Originally only default 60 and 100 percent based widths were allowed in RTE figure settings,
 * so they were stored as unitless values. These defualt values were later moved to bootflow and
 * then the UI expaned to allow setting custom widths as % or px values. In the legacy canvas
 * the unitless values that ended up getting persisted in that churn were just ignored.
 *
 * The React canvas was interpreting these unitless values as px widths breaking layouts making the figures 60px small.
 *
 * This Patch finds RTE figure images that still have unitless maxWidths and makes them explitely % values.
 *
 */

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const rteFigureMaxWidth = data.figure && data.figure.maxWidth;
  const patchNeeded =
    rteFigureMaxWidth && unitlessNumberRegex.test(rteFigureMaxWidth);

  return {
    needed: patchNeeded,
    logData: {
      msg: 'RTE Figure With Unitless Max-Width',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const newMaxWidth = rteFigureMaxWidth + '%';

      data.figure.maxWidth = newMaxWidth;

      if (data.style && data.style['max-width']) {
        data.style['max-width'] = newMaxWidth;
      }
    },
  };
};
